import { NotifyHelper } from "../../../helpers/toast";
import { edongBoHocPhiActionsObj } from "../../action-types/dong-bo/IDongBoHocPhiAction";
import { generateActionForKey, generateActions } from "../generateActions";

export const dongBoHocPhiActions = {
  ...generateActions(edongBoHocPhiActionsObj, "DONG_BO_HOC_PHI"),
  ...generateActionForKey(
    edongBoHocPhiActionsObj,
    "DONG_BO_HOC_PHI",
    "SYNC_SUCCESS",
    (m) => {
      NotifyHelper.Success("Đồng bộ thành công");
    }
  ),
  ...generateActionForKey(
    edongBoHocPhiActionsObj,
    "DONG_BO_HOC_PHI",
    "SYNC_ERR",
    (m: string) => {
      NotifyHelper.Error(m || "Đồng bộ thất bại");
    }
  ),
  ...generateActionForKey(
    edongBoHocPhiActionsObj,
    "DONG_BO_HOC_PHI",
    "HOAN_VE_VI_SUCCESS",
    (m: string) => {
      NotifyHelper.Success(m || "Đã hoàn về ví");
    }
  ),
  ...generateActionForKey(
    edongBoHocPhiActionsObj,
    "DONG_BO_HOC_PHI",
    "HOAN_VE_VI_ERR",
    (m: string) => {
      NotifyHelper.Error(m || "Chưa hoàn về ví được");
    }
  ),
  ...generateActionForKey(
    edongBoHocPhiActionsObj,
    "DONG_BO_HOC_PHI",
    "HOAN_VE_VI_LOAD_ERR",
    (m: string) => {
      NotifyHelper.Error(m || "Chưa tải được danh sách khoản ví đã trả");
    }
  ),
};
